export function maskEmail(email) {
      if (email && email.trim()) {
      const atIndex = email.indexOf("@");
      const username = email.slice(0, atIndex);
      const domain = email.slice(atIndex + 1);
      const beforeEmail =
        username.length >= 3
          ? "*".repeat(username.length - 3) + username.slice(-3)
          : username;
      const afterEmail =
        domain.length >= 5
          ? "*".repeat(domain.length - 5) + domain.slice(-5)
          : domain;
      const transformedEmail = beforeEmail + "@" + afterEmail;
      return transformedEmail;
    }
    return "";
}

export function maskPhoneNumber(phoneNumber) {
    if (phoneNumber && phoneNumber.trim()) {
      return phoneNumber.length >= 4
        ? "+91 " +
            "*".repeat(phoneNumber.length - 4) +
            phoneNumber.substring(phoneNumber.length - 4)
        : "+91" + phoneNumber;
    }
    return "";
}
